import React, { useState, useEffect } from 'react';
import { Link } from 'react-router-dom';
import { groupService, authService } from '../../services/api';
import AppAlert from '../../components/AppAlert';

/**
 * Página que lista todos os grupos do usuário com design moderno.
 */
const GroupsPage = () => {
  const [groups, setGroups] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState('');
  const user = authService.getCurrentUser();

  useEffect(() => {
    loadGroups();
  }, []);

  const loadGroups = async () => {
    try {
      setLoading(true);
      const data = await groupService.getByUser(user.userId);
      setGroups(data);
    } catch (err) {
      setError('Erro ao carregar grupos');
    } finally {
      setLoading(false);
    }
  };

  const getGroupIcon = (index) => {
    const icons = [
      'fa-users', 'fa-house', 'fa-plane', 'fa-party-horn', 
      'fa-utensils', 'fa-gamepad', 'fa-futbol', 'fa-music'
    ];
    return <i className={`fa-duotone ${icons[index % icons.length]}`}></i>;
  };

  if (loading) {
    return (
      <div className="page-container">
        <div className="loading-container">
          <div className="loading-spinner"></div>
          <p className="loading-text">Carregando seus grupos...</p>
        </div>
      </div>
    );
  }

  return (
    <div className="page-container">
      {/* Header */}
      <div className="page-header">
        <h1 className="page-title">
          <i className="fa-duotone fa-folder-open page-title-icon"></i>
          Meus Grupos
        </h1>
        <Link to="/groups/new" className="btn btn-primary">
          <i className="fa-solid fa-plus"></i>
          Novo Grupo
        </Link>
      </div>

      {/* Error */}
      {error && (
        <AppAlert
          variant="error"
          message={error}
          onClose={() => setError('')}
          style={{ marginBottom: 24 }}
        />
      )}

      {/* Content */}
      {groups.length === 0 ? (
        <div className="empty-state animate-fadeIn">
          <div className="empty-state-icon"><i className="fa-duotone fa-folder-open"></i></div>
          <h3 className="empty-state-title">Nenhum grupo ainda</h3>
          <p className="empty-state-text">
            Crie seu primeiro grupo para começar a dividir despesas com seus amigos!
          </p>
          <Link to="/groups/new" className="btn btn-primary btn-lg">
            <i className="fa-solid fa-plus"></i>
            Criar meu primeiro grupo
          </Link>
        </div>
      ) : (
        <div style={{ 
          display: 'grid', 
          gridTemplateColumns: 'repeat(auto-fill, minmax(320px, 1fr))', 
          gap: '20px' 
        }}>
          {groups.map((group, index) => (
            <Link 
              key={group.id} 
              to={`/groups/${group.id}`} 
              className="group-card animate-fadeIn"
              style={{ animationDelay: `${index * 0.1}s` }}
            >
              <div className="group-card-icon">
                {getGroupIcon(index)}
              </div>
              <h3 className="group-card-title">{group.name}</h3>
              <p className="group-card-description">
                {group.description || 'Sem descrição'}
              </p>
              <div className="group-card-meta">
                <span className="group-card-meta-item">
                  <i className="fa-solid fa-user"></i> {group.memberCount || 0} membros
                </span>
                <span className="group-card-meta-item">
                  <i className="fa-solid fa-pen"></i> Criado por {group.ownerName || 'você'}
                </span>
              </div>
            </Link>
          ))}
        </div>
      )}
    </div>
  );
};

export default GroupsPage;
